/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Clearance } from '../models/Clearance';
import type { ClearanceDetail } from '../models/ClearanceDetail';
import type { ClearanceHistory } from '../models/ClearanceHistory';
import type { ClearanceNote } from '../models/ClearanceNote';
import type { ClearanceStatusHistory } from '../models/ClearanceStatusHistory';
import type { ConnectedFacility } from '../models/ConnectedFacility';
import type { ConnectedFacilityCreate } from '../models/ConnectedFacilityCreate';
import type { ConnectedFacilityEventHistory } from '../models/ConnectedFacilityEventHistory';
import type { ConnectedFacilityHistory } from '../models/ConnectedFacilityHistory';
import type { ConnectedFacilityNote } from '../models/ConnectedFacilityNote';
import type { ConnectedFacilityPublic } from '../models/ConnectedFacilityPublic';
import type { ConnectedFacilityStatusHistory } from '../models/ConnectedFacilityStatusHistory';
import type { PaginatedClearanceList } from '../models/PaginatedClearanceList';
import type { PaginatedClearanceNoteList } from '../models/PaginatedClearanceNoteList';
import type { PaginatedConnectedFacilityNoteList } from '../models/PaginatedConnectedFacilityNoteList';
import type { PaginatedConnectedFacilityOptimizedList } from '../models/PaginatedConnectedFacilityOptimizedList';
import type { PatchedClearanceDetail } from '../models/PatchedClearanceDetail';
import type { PatchedClearanceNote } from '../models/PatchedClearanceNote';
import type { PatchedClearanceStatusUpdate } from '../models/PatchedClearanceStatusUpdate';
import type { PatchedConnectedFacility } from '../models/PatchedConnectedFacility';
import type { PatchedConnectedFacilityEventUpdate } from '../models/PatchedConnectedFacilityEventUpdate';
import type { PatchedConnectedFacilityNote } from '../models/PatchedConnectedFacilityNote';
import type { PatchedConnectedFacilityStatusUpdate } from '../models/PatchedConnectedFacilityStatusUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConnectionsService {

    /**
     * @returns PaginatedClearanceList
     * @throws ApiError
     */
    public static connectionsClearanceList({
        healthcareEntity,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        status,
        statusCategory,
        statusKind,
    }: {
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedClearanceList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/clearance/',
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns ClearanceNote
     * @throws ApiError
     */
    public static connectionsClearanceNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Clearance Note.
         */
        id: string,
        requestBody: ClearanceNote,
    }): CancelablePromise<ClearanceNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/connections/clearance-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClearanceNote
     * @throws ApiError
     */
    public static connectionsClearanceNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Clearance Note.
         */
        id: string,
        requestBody?: PatchedClearanceNote,
    }): CancelablePromise<ClearanceNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/clearance-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static connectionsClearanceNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Clearance Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/connections/clearance-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ClearanceDetail
     * @throws ApiError
     */
    public static connectionsClearanceRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
    }): CancelablePromise<ClearanceDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/clearance/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ClearanceDetail
     * @throws ApiError
     */
    public static connectionsClearanceUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        requestBody?: ClearanceDetail,
    }): CancelablePromise<ClearanceDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/connections/clearance/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClearanceDetail
     * @throws ApiError
     */
    public static connectionsClearancePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        requestBody?: PatchedClearanceDetail,
    }): CancelablePromise<ClearanceDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/clearance/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static connectionsClearanceDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/connections/clearance/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns ClearanceHistory
     * @throws ApiError
     */
    public static connectionsClearanceChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<ClearanceHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/clearance/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns PaginatedClearanceNoteList
     * @returns ClearanceNote
     * @throws ApiError
     */
    public static connectionsClearanceNotesList({
        id,
        healthcareEntity,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedClearanceNoteList | ClearanceNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/clearance/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedClearanceNoteList
     * @returns ClearanceNote
     * @throws ApiError
     */
    public static connectionsClearanceNotesCreate({
        id,
        requestBody,
        healthcareEntity,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        requestBody: ClearanceNote,
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedClearanceNoteList | ClearanceNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/connections/clearance/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ClearanceStatusHistory
     * @throws ApiError
     */
    public static connectionsClearanceStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<ClearanceStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/clearance/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns Clearance
     * @throws ApiError
     */
    public static connectionsClearanceStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Clearance.
         */
        id: string,
        requestBody?: PatchedClearanceStatusUpdate,
    }): CancelablePromise<Clearance> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/clearance/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedConnectedFacilityOptimizedList
     * @throws ApiError
     */
    public static connectionsConnectedFacilityList({
        clearanceStatus,
        facility,
        healthcareEntity,
        healthcareEntityRep,
        includeRateHistory,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * Clearance Status
         */
        clearanceStatus?: Array<string>,
        facility?: string,
        healthcareEntity?: string,
        healthcareEntityRep?: string,
        /**
         * If true, include rate_history in list responses (more expensive).
         */
        includeRateHistory?: boolean,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedConnectedFacilityOptimizedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/',
            query: {
                'clearance_status': clearanceStatus,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'healthcare_entity_rep': healthcareEntityRep,
                'include_rate_history': includeRateHistory,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityCreate({
        requestBody,
    }: {
        requestBody: ConnectedFacilityCreate,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/connections/connected-facility/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConnectedFacilityNote
     * @throws ApiError
     */
    public static connectionsConnectedFacilityNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility Note.
         */
        id: string,
        requestBody: ConnectedFacilityNote,
    }): CancelablePromise<ConnectedFacilityNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/connections/connected-facility-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConnectedFacilityNote
     * @throws ApiError
     */
    public static connectionsConnectedFacilityNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility Note.
         */
        id: string,
        requestBody?: PatchedConnectedFacilityNote,
    }): CancelablePromise<ConnectedFacilityNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/connected-facility-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static connectionsConnectedFacilityNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Connected Facility Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/connections/connected-facility-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Public endpoint:
     * GET ?provider=<uuid>&facility=<uuid>
     *
     * Returns a single ConnectedFacility record (or 404).
     * @returns ConnectedFacilityPublic
     * @throws ApiError
     */
    public static connectionsConnectedFacilityPublicLookupRetrieve({
        availabilityToken,
        facility,
    }: {
        /**
         * Provider Availability Token
         */
        availabilityToken?: string,
        /**
         * Facility ID
         */
        facility?: string,
    }): CancelablePromise<ConnectedFacilityPublic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility-public/lookup/',
            query: {
                'availability_token': availabilityToken,
                'facility': facility,
            },
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        requestBody?: ConnectedFacility,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/connections/connected-facility/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        requestBody?: PatchedConnectedFacility,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/connected-facility/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Handles the retrieval of change history for an instance.
     * The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the instance.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns ConnectedFacilityHistory
     * @throws ApiError
     */
    public static connectionsConnectedFacilityChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<ConnectedFacilityHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns ConnectedFacilityEventHistory
     * @throws ApiError
     */
    public static connectionsConnectedFacilityEventHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<ConnectedFacilityEventHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/{id}/event-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityEventUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        requestBody?: PatchedConnectedFacilityEventUpdate,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/connected-facility/{id}/event-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedConnectedFacilityNoteList
     * @returns ConnectedFacilityNote
     * @throws ApiError
     */
    public static connectionsConnectedFacilityNotesList({
        id,
        clearanceStatus,
        facility,
        healthcareEntity,
        healthcareEntityRep,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        /**
         * Clearance Status
         */
        clearanceStatus?: Array<string>,
        facility?: string,
        healthcareEntity?: string,
        healthcareEntityRep?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedConnectedFacilityNoteList | ConnectedFacilityNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'clearance_status': clearanceStatus,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'healthcare_entity_rep': healthcareEntityRep,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedConnectedFacilityNoteList
     * @returns ConnectedFacilityNote
     * @throws ApiError
     */
    public static connectionsConnectedFacilityNotesCreate({
        id,
        requestBody,
        clearanceStatus,
        facility,
        healthcareEntity,
        healthcareEntityRep,
        limit,
        offset,
        ordering,
        provider,
        queue,
        reason,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        requestBody: ConnectedFacilityNote,
        /**
         * Clearance Status
         */
        clearanceStatus?: Array<string>,
        facility?: string,
        healthcareEntity?: string,
        healthcareEntityRep?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * Reason
         */
        reason?: Array<string | null>,
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedConnectedFacilityNoteList | ConnectedFacilityNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/connections/connected-facility/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'clearance_status': clearanceStatus,
                'facility': facility,
                'healthcare_entity': healthcareEntity,
                'healthcare_entity_rep': healthcareEntityRep,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'queue': queue,
                'reason': reason,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConnectedFacilityStatusHistory
     * @throws ApiError
     */
    public static connectionsConnectedFacilityStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<ConnectedFacilityStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connections/connected-facility/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static connectionsConnectedFacilityStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Connected Facility.
         */
        id: string,
        requestBody?: PatchedConnectedFacilityStatusUpdate,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connections/connected-facility/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
